import { useState, useEffect } from 'react';
import { UseAnimatedTextOptions, UseAnimatedTextReturn } from './types';

export const useAnimatedText = ({
  texts,
  interval = 2000,
  loop = true,
}: UseAnimatedTextOptions): UseAnimatedTextReturn => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (!texts.length) return;

    const timer = setInterval(() => {
      setIsAnimating(true);

      setTimeout(() => {
        setCurrentIndex((prevIndex) => {
          if (!loop && prevIndex === texts.length - 1) {
            return prevIndex;
          }
          return (prevIndex + 1) % texts.length;
        });
        setIsAnimating(false);
      }, 300); // Tempo para a animação de fade out
    }, interval);

    return () => clearInterval(timer);
  }, [texts, interval, loop]);

  return {
    currentText: texts[currentIndex] || '',
    currentIndex,
    isAnimating,
  };
};
